/**
 * Created by shaharshelly on 11/27/15.
 */
import Marionette from 'backbone.marionette';

export default Marionette.Region.extend({
  el: '#modalViewContainer',

  onShow: function () {
    this.$el.show();
    this.$el.on('click', this.emptyMyself.bind(this));
  },

  emptyMyself: function (e) {
    if (e.target === e.currentTarget) {
      // we're clicking on the modal's mask, not on the modal's content
      this.empty();
    }
  },

  onEmpty: function () {
    this.currentView.destroy();
    this.$el.off('click');
    this.$el.hide();
  },
});
